var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5594 7.31894H18.7458C18.2802 7.31894 17.8941 6.99873 17.8941 6.6126C17.8941 6.22646 18.2802 5.90625 18.7458 5.90625H25.5594C26.025 5.90625 26.4111 6.22646 26.4111 6.6126C26.4111 6.99873 26.025 7.31894 25.5594 7.31894Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38986 7.31894H2.84748C2.38189 7.31894 1.99579 6.99873 1.99579 6.6126C1.99579 6.22646 2.38189 5.90625 2.84748 5.90625H7.38986C7.85545 5.90625 8.24155 6.22646 8.24155 6.6126C8.24155 6.99873 7.85545 7.31894 7.38986 7.31894Z",
    fill: "#101828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9322 10.6146C9.27494 10.6146 7.10596 8.81581 7.10596 6.612C7.10596 4.4082 9.27494 2.60938 11.9322 2.60938C14.5895 2.60938 16.7585 4.4082 16.7585 6.612C16.7585 8.81581 14.5895 10.6146 11.9322 10.6146ZM11.9322 4.02207C10.2061 4.02207 8.80935 5.18048 8.80935 6.612C8.80935 8.04353 10.2061 9.20194 11.9322 9.20194C13.6583 9.20194 15.0551 8.04353 15.0551 6.612C15.0551 5.18048 13.6583 4.02207 11.9322 4.02207Z",
    fill: "#101828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5594 17.6783H21.017C20.5514 17.6783 20.1653 17.3581 20.1653 16.972C20.1653 16.5858 20.5514 16.2656 21.017 16.2656H25.5594C26.0249 16.2656 26.411 16.5858 26.411 16.972C26.411 17.3581 26.0249 17.6783 25.5594 17.6783Z",
    fill: "#101828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66104 17.6783H2.84748C2.38189 17.6783 1.99579 17.3581 1.99579 16.972C1.99579 16.5858 2.38189 16.2656 2.84748 16.2656H9.66104C10.1266 16.2656 10.5127 16.5858 10.5127 16.972C10.5127 17.3581 10.1266 17.6783 9.66104 17.6783Z",
    fill: "#101828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4746 20.974C13.8173 20.974 11.6483 19.1752 11.6483 16.9714C11.6483 14.7676 13.8173 12.9688 16.4746 12.9688C19.1319 12.9688 21.3009 14.7676 21.3009 16.9714C21.3009 19.1752 19.1319 20.974 16.4746 20.974ZM16.4746 14.3814C14.7485 14.3814 13.3517 15.5399 13.3517 16.9714C13.3517 18.4029 14.7485 19.5613 16.4746 19.5613C18.2007 19.5613 19.5975 18.4029 19.5975 16.9714C19.5975 15.5399 18.2007 14.3814 16.4746 14.3814Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting4);
export default __webpack_public_path__ + "static/media/setting-4.14bd1e8a3f5cd345c7322308e52a933a.svg";
export { ForwardRef as ReactComponent };